import { createRxDatabase } from 'rxdb';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';

const schema = {
    title: 'client account schema',
    version: 0,
    primaryKey: 'login',
    type: 'object',
    properties: {
        login: {
            type: 'string',
        },
        address: {
            type: 'string',
        },
        token: {
            type: 'string',
        },
        iv: {
            type: 'array',
            items: {
                type: 'number',
            },
        }
    },
    required: ['login', 'address', 'token'],
};

let dbPromise = null;

export async function getDatabase() {
  if (!dbPromise) {
    dbPromise = createRxDatabase({
      name: 'client_accounts', // Назва бази даних
      storage: getRxStorageDexie(), // Підключення Dexie
    }).then(async (db) => {
      await db.addCollections({
        accounts: {
          schema,
        },
      });
      return db;
    });
  }
  return dbPromise;
}
